module.exports = __webpack_public_path__ + "app/principal/principal-acquittal-36rQXZhl.html";